export default theme => ({
    appBar: {
        position: 'relative',
        backgroundColor: theme.palette.primary?.main || '#0F48B8',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
        fontWeight: 700,
    },
    facilityLabel: {
        display: 'block',
        fontFamily: 'Inter, sans-serif',
        fontSize: 14,
        fontWeight: 700,
        letterSpacing: '0.28px',
        color: theme.palette.primary?.main || 'var(--primary-blue-primary-main, #0F48B8)',
        marginBottom: theme.spacing(1),
        marginTop: 0,
    },
    field: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    cancelBtn: {
        textTransform: 'uppercase',
    },
    saveBtn: {
        marginLeft: 10,
        paddingLeft: 31,
        paddingRight: 31,
        textTransform: 'uppercase',
    },
    dialogContent: {
        paddingTop: 40,
        paddingBottom: 40,
        paddingLeft: 24,
        paddingRight: 24,
    },
    dialogActions: {
        paddingBottom: 25,
        paddingTop: 0,
        justifyContent: 'center',
    },
})